interface GroupNameFieldProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  label?: string
  placeholder?: string
  hint?: string
}

export default function GroupNameField({
  value,
  onChange,
  disabled = false,
  label = 'Group Name (optional)',
  placeholder = 'Auto-named after customer’s last name',
  hint = 'Leave blank and we’ll name it “{Last Name} Farm” after the customer registers. The customer can rename it later.',
}: GroupNameFieldProps) {
  return (
    <div>
      <label className="block text-sm font-medium mb-2">{label}</label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={36}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
      />
      {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
    </div>
  )
}
